/**
 * A sigla de um nome — "Arena Alpha" → "AA", "Duna" → "DU".
 *
 * É o que identifica a arena no seletor do menu e na lista de arenas do
 * login. Sem logo por arena, a sigla é o que as distingue de relance.
 */
export function siglaDe(nome: string): string {
  const palavras = nome.trim().split(/\s+/).filter(Boolean);
  if (palavras.length === 0) return '·';
  if (palavras.length === 1) return palavras[0]!.slice(0, 2).toUpperCase();
  return palavras
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('');
}
